import React from "react";
import { FaTachometerAlt, FaBell, FaMapMarkerAlt, FaTimes, FaCogs, FaMicrochip, FaHome, FaChartBar } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/", icon: <FaHome /> },
    { name: "Devices", path: "/devices", icon: <FaMicrochip /> },
    { name: "Map", path: "/map", icon: <FaMapMarkerAlt /> },
    { name: "Alerts", path: "/alerts", icon: <FaBell /> },
    { name: "Reports", path: "/reports", icon: <FaChartBar /> },
    { name: "Settings", path: "/settings", icon: <FaCogs /> },
  ];

  return (
    <>
      {/* Overlay for Mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleSidebar}
        ></div>
      )}

<div
  className={`fixed lg:static top-0 left-0 h-screen lg:h-auto bg-gray-950 text-white w-64 p-4 
  ${isOpen ? "z-50 translate-x-0" : "-translate-x-full"} 
  lg:z-auto lg:translate-x-0 transition-transform duration-300 overflow-y-auto lg:flex-shrink-0`}
>

        {/* Header with Logo & Close Button */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-2">
            <img src="/logo192.png" alt="Logo" className="w-8 h-8" />
            <span className="font-bold text-lg">IoT Panel</span>
          </div>
          <button onClick={toggleSidebar} className="lg:hidden">
            <FaTimes className="text-2xl" />
          </button>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col gap-3">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.name}
                to={item.path}
                onClick={toggleSidebar}
                className={`flex items-center gap-3 px-4 py-2 rounded-lg transition-all 
                  ${isActive ? "bg-green-600 text-white font-semibold" : "hover:bg-gray-800 hover:text-green-400"}
                `}
              >
                {item.icon} {item.name}
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
